module.exports = __webpack_public_path__ + "static/media/miaspharma.1e9ec9ce.png";